import { URI_TARIFF_PLAN } from '@/config/config';

export default async ({ rootState }, payload) => {
  const token = rootState['DATA-ACCESS'].tokenAuth;
  const userToken = rootState['DATA-ACCESS'].userToken;
  const opts = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
      'user-token': userToken
    },
    body: JSON.stringify(payload)
  };

  const url = new URL(`${URI_TARIFF_PLAN}payment/reactive-payment-list`);
  // url.search = new URLSearchParams(payload).toString();
  const response = await fetch(url, opts);
  const jsonResult = await response.json();
  if (jsonResult.errors) {
    return Promise.reject(jsonResult.errors);
  }

  return jsonResult.credits;
};
